<template>
    <div v-if="address?.company">
        {{ address.company }}
    </div>
    <template v-if="address">
        <div>
            <template v-if="salutationsLoaded">{{ getSalutationDisplay }}</template> {{ address.firstName }} {{ address.lastName }}
        </div>
        <div>
            {{ address.street }}
        </div>
        <div>
            {{ address.zipcode }} {{ address.city }}
        </div>
        <div>
            {{ address.country?.name }}
        </div>
    </template>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    address?: Schemas['CustomerAddress'] | Schemas['OrderAddress']
}>()

const { getSalutations } = useSalutations()

// Track if salutations are loaded to prevent layout shift
const salutationsLoaded = computed(() => getSalutations.value.length > 0)

const getSalutationDisplay = computed(() => {
    // CustomerAddress has salutationId directly; OrderAddress only has the salutation relation
    const salutationId = 'salutationId' in (props.address ?? {})
        ? (props.address as Schemas['CustomerAddress']).salutationId
        : props.address?.salutation?.id
    if (!salutationId) return ''
    const salutation = getSalutations.value.find(s => s.id === salutationId)
    return salutation?.translated?.displayName || salutation?.displayName
})
</script>
